import React from "react";
import {
    IonButtons,
    IonContent,
    IonHeader,
    IonItem,
    IonLabel,
    IonList,
    IonMenuButton,
    IonPage, IonSelect, IonSelectOption, IonItemDivider,
    IonTitle,
    IonToolbar,
    IonText,
    IonButton
} from "@ionic/react";
import { inject } from "mobx-react";
import { InputChangeEventDetail } from "@ionic/core";
import { Store } from "../service/Store";
import moment from "moment";

@inject("store", "lang")
export default class Settings extends React.Component<any, any> {

    state = {
        lora : [],
    } as any;
    handleChangeSerial = (ev: CustomEvent<InputChangeEventDetail>) => {
        let store: Store = this.props.store;
        store.setItem("serialId", ev.detail.value);
    }
    handleChangeChart = (ev: CustomEvent<InputChangeEventDetail>) => {
        let store: Store = this.props.store;
        store.setItem("chartEngine", ev.detail.value);
    }
    handleChangeTimeZone = (ev: CustomEvent<any>) => {
        let store: Store = this.props.store;
        store.timeZone = ev.detail.value;
        store.setItem("timeZone", ev.detail.value);
        this.setState({});
    }
    handleResetSiri = (ev: any) => {
        let store: Store = this.props.store;
        store.siri!.deleteAll().then(() => {
            alert("OK");
        });
    }

    handleLoadLora() {
        let store: Store = this.props.store;
        store.api.internalCall("admin/api/lora/auto_discovery", "GET", {}).then((response) => {

            this.setState({ lora: [] });
            response.json().then((value: any) => {
                if (value.success) {
                    this.setState({ lora: value.data });
                } else {
                    alert(value.error);
                }

            });


        });
    }

    renderLora() {
        let list = this.state.lora;

        return <table>
            <tr>
                <th>Device ID</th>
                <th>Date</th>
                <th>Mode</th>
                <th>Uplink Message</th>
            </tr>
            {list.reverse().map((value: any) => {
                return <tr key={value.deviceId}>
                    <td>{value.deviceId}</td>
                    <td>{moment(value.date).format("YYYY-MM-DD HH:mm:ss")}</td>
                    <td>{value.mode}</td>
                    <td><code>{JSON.stringify(value.uplinkMessage)}</code></td>
                </tr>
            })}
        </table>
    }

    renderAdmin() {
        let store: Store = this.props.store;

        return <>

            <IonItemDivider>
                <IonLabel>
                    Admin Features
                </IonLabel>
            </IonItemDivider>
            <IonItem>
                <IonButton onClick={() => store.socket?.emit('resetMQTT')}>Reiniciar MQTT</IonButton>
            </IonItem>
            <IonItem>
                <IonButton onClick={() => this.handleLoadLora()}>Lora Autodiscover</IonButton>
            </IonItem>
            {this.state.lora && this.renderLora()}
        </>;
    }
    render() {
        let store: Store = this.props.store;
        const { lang } = this.props;
        // let id = store.getItem("serialId");
        // let chart = store.getItem("chartEngine") || 0;
        let timeZones = moment.tz.names();
        let currentTimeZone = store.timeZone;
        return <IonPage>
            <IonHeader>
                <IonToolbar color={"primary"}>
                    <IonButtons slot={"start"}><IonMenuButton /></IonButtons>
                    <IonTitle>{lang?.l.main.app_settings_title()}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonList>
                    <IonItem>
                        <IonSelect label={lang?.l.main.app_settings_timezone()} interface="action-sheet" value={currentTimeZone} onIonChange={this.handleChangeTimeZone}>
                            {timeZones.map(timeZone => <IonSelectOption value={timeZone}>{timeZone} {moment().tz(timeZone).format('Z')}</IonSelectOption>)}
                        </IonSelect>
                    </IonItem>
                    <IonItem>
                        <IonLabel>{lang?.l.main.app_settings_current_time()}</IonLabel>
                        <IonText>{store.moment(new Date()).format()}</IonText>
                    </IonItem>
                    <IonItem hidden={!store.siri || !store.siri.available} onClick={this.handleResetSiri}>
                        <IonLabel>Reiniciar Siri</IonLabel>
                    </IonItem>
                    {this.props.store.user.privileges >= 100 && this.renderAdmin()}
                </IonList>


            </IonContent>
        </IonPage>
    }
}
